<template>
<div>
  <v-navigation-drawer
      fixed
      v-model="$store.state.drawer"
      app
      class="darken"
      width="250"
    >
      <v-layout fill-height>
        <v-list class="grow darken pt-4"  v-if="$route.name == 'home'">
          <MainMenu></MainMenu>
          <v-divider class="menu--divide" light></v-divider>
          <SocialMenu></SocialMenu>
        </v-list>
        <v-list class="grow darken pt-4" v-else>
          <v-list-item
            active-class="menu--active"
            v-ripple
            href="/"
          >            
            <v-list-item-title class="menu--item">Home</v-list-item-title>
          </v-list-item>
          <v-divider class="menu--divide" light></v-divider>
          <SocialMenu></SocialMenu>
        </v-list>        
      </v-layout>
    </v-navigation-drawer>
    <v-app-bar color="primary" dark fixed app text style="bottom-border: 0px;z-index: 9997">
      <v-btn @click="$store.state.drawer = !$store.state.drawer, runBounce(), resetFace()" text dark color="white" class="animated menu--btn-wrap" :class="{ rubberBand: clicked }">
        <v-icon class="menu--btn2">menu</v-icon>
      </v-btn>
      <v-app-bar-title class="heading-tool ml-2">she</v-app-bar-title>
    </v-app-bar>
</div>
</template>

<script>
import SocialMenu from "./SocialMenu.vue";
import MainMenu from "./MainMenu.vue";
import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      clicked: true
    }
  },
  methods: {
    ...mapMutations([
      'resetFace'
    ]),
    runBounce() {
      this.clicked = false
      setTimeout(() => this.clicked = true, 20)
    }
  },
  computed: {
    menuBar() {
      if (!this.$store.state.drawer) {
        return 'menu'
      }
      else return 'close'
    }
  },
  components: {
    SocialMenu,
    MainMenu
  }
}
</script>

<style lang="scss">
.menu {
    &--btn {
      background: #6075bd;
      padding: 7px;
      width: 40px;
      border-radius: 6px;
      color: #fff !important;
      &:hover {
        background: #677eca;
      }
    }
    &--divide {
      width: 80%;
      margin: 10px auto;
      border-color: rgba(255, 255, 255, 0.36) !important;
    }
    &--btn-wrap {
      right: 10px;
      min-width: 36px !important;
      padding: 0 !important
    }
    &--title {
      margin: 0;
      padding-top: 28px;
      font-family: 'Baloo', sans-serif;
      
    }
    &--item {
      color: white;
      font-size: 2rem;
      font-family: 'Baloo', cursive !important;
    }
  }
  .v-navigation-drawer--is-mobile {
    margin-top: 47px !important;
    z-index: 999;
}

</style>
